"use strict";

exports.onRouteUpdate = function (_ref) {
  var location = _ref.location;

  // Don't track while developing.
  if (process.env.NODE_ENV === "production" && typeof ga === "function") {
    ga("set", "page", (location || {}).pathname);
    ga("send", "pageview");
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-google-analytics/gatsby-browser.js
// module id = ./node_modules/gatsby-plugin-google-analytics/gatsby-browser.js
// module chunks = 231608221292675